module.exports = __webpack_public_path__ + "img/download-white-stacked.25236e21.png";